import styled from "@emotion/styled";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
} from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from "@mui/icons-material/Close";
import { useCallback } from "react";
import { useIntercomIntegration } from "@shared/services/intercom/useIntercomIntegration";
import { Form } from "@shared/components/Form";
import { useUIStore } from "@store/ui.store";

const ChoiceButton = styled(Button)`
  text-align: left;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  margin-bottom: 0.25rem;
`;

export const IntercomChatSupport = () => {
  const supportDialogMode = useUIStore(
    (state) => state.supportDialogOptions.mode,
  );
  const toggleSupportDialogMode = useUIStore(
    (state) => state.toggleSupportDialogMode,
  );
  const { show } = useIntercomIntegration();

  const onClose = () => toggleSupportDialogMode({ mode: null });

  const handleClickNewSupportRequest = useCallback(() => {
    toggleSupportDialogMode({ mode: "support-request" });
  }, [toggleSupportDialogMode]);

  const handleShowMessages = () => {
    onClose();
    show();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      onClose={onClose}
      open={supportDialogMode === "home"}
    >
      <DialogTitle id="support-dialog-title">
        Support{" "}
        <IconButton
          sx={{ position: "absolute", right: "1rem", top: "1rem" }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent id="support-dialog-content">
        <Form>
          <Typography mb={2}>Please select an option to continue</Typography>
          <ChoiceButton
            variant="outlined"
            size="small"
            onClick={handleClickNewSupportRequest}
          >
            New support request <SendIcon />
          </ChoiceButton>
          <ChoiceButton
            variant="outlined"
            size="small"
            onClick={handleShowMessages}
          >
            Support messages <CommentIcon />
          </ChoiceButton>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
